/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hidden[_ngcontent-%COMP%]{visibility:hidden}.start-loader-overlay[_ngcontent-%COMP%]{display:block;position:absolute;width:100%;height:100%;z-index:50000;top:0;background-color:rgba(0,0,0,.2);content:\"\"}.start-loader[_ngcontent-%COMP%]{content:\"\";position:absolute;overflow:hidden;left:49%;top:45%;width:50px;height:50px;background-image:url(/assets/images/busy.gif);background-position:center;background-size:contain}"];
export { styles as styles };
